import { FC, memo } from 'react'
import { equals } from 'ramda'
import { RoomTypes } from '@weblite/ts-action/room'
import { useRoomAttribute } from '$logic/room/react-hook'
import { HallChatListItem } from './hall-chat-list-item'
import { PvChatListItem } from './pv-chat-list-item'
import { PrivateSpaceChatListItem } from './private-space-chat-list-item'
import { ChatListItemSkeleton } from './chat-list-item-skeleton'
import { WappRoomChatListItem } from './wapp-room-chat-list-item'
import { ChatListItemProps } from './chat-list-item.types'

const ComponentMapper: Record<RoomTypes, FC<ChatListItemProps>> = {
  CHANNEL: HallChatListItem,
  GROUP: HallChatListItem,
  PV: PvChatListItem,
  WAPP_ROOM: WappRoomChatListItem,
  PRIVATE_SPACE: PrivateSpaceChatListItem,
}
export const ChatListItem = memo(function ChatListItemComponent({
  chatId,
  pinned,
  isOnTop,
  selected,
  onClick,
  onContextMenu,
  onLongPress,
  isOpened,
}: ChatListItemProps) {
  const roomType = useRoomAttribute('type', chatId)

  if (!chatId) return null
  if (!roomType) return <ChatListItemSkeleton />

  const Component = ComponentMapper[roomType]
  return Component ? (
    <Component
      chatId={chatId}
      selected={selected}
      pinned={pinned}
      isOnTop={isOnTop}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onLongPress={onLongPress}
      isOpened={isOpened}
    />
  ) : (
    <ChatListItemSkeleton />
  )
},
equals)
